import React, {useEffect, useState, useRef} from "react";
import {API, processApiResponse} from "../../services/HttpHandler";
import {checkContentAvlInArray} from "../../util";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import QRCode from "qrcode.react";
import BookingDetailList from "../../components/BookingDetailList";
import BlockBtn from "../../components/BlockBtn";
import Loader from "../../components/Loader";
import TabsMenu from "../../components/TabsMenu";
import {getCustomerSlotDetails} from "../../services/SessionStorage";
import config from "config";

import "./style.scss";
import "../../components/Loader/style.scss";

const CurrentBooking = () => {
  const [loading, setLoading] = useState(false);
  const [dataLoad, setDataLoad] = useState(false);
  const [QRData, setQRData] = useState(null);
  const [error, setError] = useState("");
  const {t} = useTranslation();
  const navigate = useNavigate();
  const customerSlotDetails = useRef(getCustomerSlotDetails());
  const performAction = () => {
    navigate("/customer/displayAppointments");
  };
  useEffect(() => {
    const qrDataUrl = config.endPoints.qrdata;
    const bookingIdPlaceHolder = /bookingIdPlaceholder/gi;
    const url = qrDataUrl.replace(
      bookingIdPlaceHolder,
      customerSlotDetails.current.appointmentuuid
    );

    try {
      setLoading(true);
      API.get(url)
        .then(processApiResponse)
        .then((resp) => {
          setQRData(resp);
          setLoading(false);
          setDataLoad(true);
        });
      setLoading(false);
    } catch (error) {
      setError("error occured");
      setLoading(false);
    } finally {
    }
  }, []);
  const isBanco = () => {
    if (customerSlotDetails.current.source.includes("bancofalabella")) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <TabsMenu path="displayAppointments" />
      <div className="main-container">
        {!loading && dataLoad ? (
          <>
            <div className="currentBooking-container">
              <h2 className="booking-detail-heading">{`Reserva ${QRData.storeName}`}</h2>
              <BookingDetailList
                endTime={isBanco() ? "" : QRData.endTime}
                isOffice={customerSlotDetails.current.isOffice}
                region={QRData.location}
                serviceType={QRData.serviceType.toString()}
                startTime={QRData.startTime}
                storeName={QRData.storeName}
                timeZone={QRData.timeZone}
                country={QRData.country}
                bu={QRData.businessUnit}
              />
              <div className="just-line">
                <hr />
              </div>

              <QRCode
                id="slotbook-qrcode"
                value={JSON.stringify(QRData)}
                renderAs={"png"}
                className="qr-image"
                size={256}
              />

              <label className="smaller-text">{t("useQRforEntry")}</label>
            </div>

            <div className="displayAppointment-footer">
              <BlockBtn
                name={t("moveto.myappnt")}
                handleClick={performAction}
                disabled={false}
              />
            </div>
          </>
        ) : (
          <div className="loader-container">
            <Loader />
          </div>
        )}
      </div>
    </>
  );
};
export default CurrentBooking;
